import { RollbackOutlined, SaveOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  message,
  Row,
  Select,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  Back,
  DefaultErrorMessage,
  Save,
  UpdateDataSuccessfully,
  Information,
  Name,
  IsActive,
} from "shared/constants/define-localization";
import { t, CoreResource } from "shared/plugins/localization";
import { setLoading } from "states/global-value/global-value.slice";
import {
  addWareHouse,
  getWareHouseById,
  updateWareHouse,
} from "states/ware-house/ware-house.api";
import { WareHouseModel } from "states/ware-house/ware-house.models";
import {
  ADD_WARE_HOUSE_ROUTE,
  WARE_HOUSE_ROUTE,
} from "shared/constants/routes";
import { getDistrictList, getProvinceList, getWardList } from "states/address/address.api";
import {
  DistrictModel,
  ProvinceModel,
  WardModel,
} from "states/address/address.models";

interface RouteParams {
  id: string;
}

export function AddUpdateWareHouse() {
  const history = useHistory();
  const { id } = useParams<RouteParams>();
  const [model, setModel] = useState<WareHouseModel>({} as WareHouseModel);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [provinces, setProvinces] = useState<ProvinceModel[]>(
    [] as ProvinceModel[]
  );
  const [districts, setDistricts] = useState<DistrictModel[]>(
    [] as DistrictModel[]
  );
  const [wards, setWards] = useState<WardModel[]>([] as WardModel[]);
  const getProvinces = async () => {
    let result = await getProvinceList();
    setProvinces(result.data);
  };
  const getDistricts = async (provinceCode: string) => {
    let result = await getDistrictList(provinceCode);
    setDistricts(result.data);
  };
  const getWards = async (districtCode: string) => {
    let result = await getWardList(districtCode);
    setWards(result.data);
  };
  const dispatch = useDispatch();

  const getWareHouse = async () => {
    try {
      const res = await getWareHouseById(Number(id));
      if(res.data.address?.provinceCode !== null){
        await getDistricts(res.data.address?.provinceCode??"");
      }
      if(res.data.address?.districtCode !== null){
        await getWards(res.data.address?.districtCode??"");
      }
      setModel(res.data);
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };

  const onSaved = async () => {
    dispatch(setLoading(true));
    try {
      if (isUpdateMode) {
        await updateWareHouse(model);
      } else {
        await addWareHouse({ ...model, id: 0 });
      }
      message.success("Cập nhật thành công");
      history.go(0);
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
    dispatch(setLoading(false));
  };
  const handleChangeAddress = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = ev.target;
    setModel({
      ...model,
      address: {
        ...model.address,
        [name]: value,
      },
    });
  };
  useEffect(() => {
    if (document.location.href.indexOf(ADD_WARE_HOUSE_ROUTE) > -1) {
      setIsUpdateMode(false);
    } else {
      setIsUpdateMode(true);
      getWareHouse();
    }
    getProvinces();
  }, []);

  return (
    <div className="add-update-wareHouse">
      <Row gutter={[16, 16]} className="mb-4">
        <Col flex="auto">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={WARE_HOUSE_ROUTE}>Kho hàng</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {isUpdateMode ? "Cập nhật" : "Thêm"} kho hàng
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col flex="auto" className="d-flex justify-content-end">
          <Link to={WARE_HOUSE_ROUTE} className="mr-2">
            <Button type="default" icon={<RollbackOutlined />}>
              {"Quay lại"}
            </Button>
          </Link>
          <Button onClick={onSaved} type="primary" icon={<SaveOutlined />}>
            {"Lưu"}
          </Button>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span="12">
          <Card title={t(CoreResource, Information)}>
            <Input.Group className="mb-4">
              <Typography.Text> {"Tên"}: </Typography.Text>
              <Input
                value={model.name}
                onChange={(e) => {
                  setModel({
                    ...model,
                    name: e.target.value,
                  });
                }}
                placeholder={"Tên"}
              ></Input>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text> Số điện thoại: </Typography.Text>
              <Input
                value={model.phoneNumber}
                name="phoneNumber"
                onChange={(e) => {
                  setModel({
                    ...model,
                    phoneNumber: e.target.value,
                  });
                }}
                placeholder="Số điện thoại"
              ></Input>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text>Tỉnh / thành phố: </Typography.Text>
              <Select
                className="w-100"
                placeholder="Tỉnh / thành phố"
                value={model?.address?.provinceCode}
                showSearch
                filterOption={(input, option) =>{
                  let result = option?.children
                  ?.toString()
                  ?.toLowerCase()
                  ?.indexOf(input?.toLowerCase())??-1;
                  return result >= 0
                  }
                }
                onChange={(value) =>{
                  setDistricts([]);
                  setWards([]);
                  let province = [...provinces].find(m=> m.provinceCode === value);
                  if(province !== undefined){
                     getDistricts(province.provinceCode);
                  }
                  setModel({...model,address:{
                    ...model.address,
                    provinceCode:value??"",
                    provinceName:province?.name??"",
                    districtCode:undefined,
                    districtName:undefined,
                    wardCode: undefined,
                    wardName:undefined,
                  }})
                }}
              >
                {provinces?.map((pr) => (
                  <Select.Option key={pr.id} value={pr.provinceCode}>
                    {pr.name}
                  </Select.Option>
                ))}
              </Select>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text>Quận / huyện: </Typography.Text>
              <Select
                className="w-100"
                placeholder="Quận / huyện"
                value={model?.address?.districtCode}
                showSearch
                filterOption={(input, option) =>{
                  let result = option?.children
                  ?.toString()
                  ?.toLowerCase()
                  ?.indexOf(input?.toLowerCase())??-1;
                  return result >= 0
                  }
                }
                onChange={(value) =>{
                  setWards([]);
                  let district = [...districts].find(m=> m.districtCode === value);
                  if(district !== undefined){
                    getWards(district.districtCode);
                 }
                  setModel({...model,address:{
                    ...model.address,
                    districtCode:value??"",
                    districtName:district?.name??"",
                    wardCode: undefined,
                    wardName:undefined,
                  }})
                }}
              >
                {districts?.map((dt) => (
                  <Select.Option key={dt.id} value={dt.districtCode}>
                    {dt.name}
                  </Select.Option>
                ))}
              </Select>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text>Phường / xã: </Typography.Text>
              <Select
                className="w-100"
                placeholder="Phường / xã"
                value={model?.address?.wardCode}
                showSearch
                filterOption={(input, option) =>{
                  let result = option?.children
                  ?.toString()
                  ?.toLowerCase()
                  ?.indexOf(input?.toLowerCase())??-1;
                  return result >= 0
                  }
                }
                onChange={(value) =>{
                  let ward = [...wards].find(m=> m.wardCode === value);
                  setModel({...model,address:{
                    ...model.address,
                    wardCode:value??"",
                    wardName:ward?.name??""
                  }})
                }}
              >
                {wards?.map((wd) => (
                  <Select.Option key={wd.id} value={wd.wardCode}>
                    {wd.name}
                  </Select.Option>
                ))}
              </Select>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text> Số nhà: </Typography.Text>
              <Input
                value={model.address?.street}
                name="street"
                onChange={handleChangeAddress}
                placeholder="Số nhà"
              ></Input>
            </Input.Group>
            <Input.Group className="mb-4">
              <Checkbox
                checked={model.isActive}
                onChange={(e) => {
                  setModel({ ...model, isActive: e.target.checked });
                }}
              >
                {t(CoreResource, IsActive)}
              </Checkbox>
            </Input.Group>
          </Card>
        </Col>
        <Col span="12"></Col>
      </Row>
    </div>
  );
}
